import React, { Component } from 'react';

class PendingCashCutModal extends Component {

    render() {
        const {
            param1,
            ChangeParam1,
            ExecuteParam1,
            ColorHeaderBG,
            IdModal,
            CloseActions,
            Title,
            headerText,
            placeholder
        } = this.props;

        return (
            <>
                <div className="modal fade" tabIndex="-1" role="dialog" data-backdrop="static" id={IdModal}>
                    <div className="modal-dialog" role="document" style={{ minWidth: 300, maxWidth: 600, margin: '1.75rem auto', borderRadius: 15 }}>
                        <div className="modal-content">

                            <div className={`modal-header ${ColorHeaderBG} justify-content-center position-relative`}>
                                <h5 className="modal-title text-center">
                                    {Title ?? ''}
                                </h5>

                                <button
                                    type="button"
                                    onClick={() => CloseActions()}
                                    className="close position-absolute"
                                    style={{ right: 15 }}
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body text-center">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">

                                        <h4 className="text-center">
                                            {headerText ?? ''}
                                        </h4>

                                        <div className="container mt-2 mb-2">
                                            <div className="row justify-content-center">
                                                <input
                                                    type="text"
                                                    style={{ height: '4vh', width: '28vh' }}
                                                    className="form-group form-control-md text-center rounded"
                                                    value={param1 ?? ''}
                                                    placeholder={placeholder ?? 'Escribe aquí'}
                                                    onChange={(event) => {
                                                        let value = event.target.value.toUpperCase();
                                                        value = value.replace(/[^A-Z0-9]/g, '');
                                                        ChangeParam1(value);
                                                    }}
                                                    onKeyDown={(event) => event.keyCode === 13 && ExecuteParam1()}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default PendingCashCutModal;